import { apiClient } from "@/lib/api-client"

// ── Recruitment ───────────────────────────────────────────────────────────────

export interface ConfirmedInterviewDto {
    interviewId: string
    candidateName: string
    candidateEmail: string
    vacancyTitle: string
    interviewTitle: string
    interviewType: string
    startTime: string
    endTime: string
}

export interface PendingCandidateDto {
    interviewId: string
    applicationId: string
    candidateName: string
    candidateEmail: string
    vacancyTitle: string
    slotsOffered: number
    slotsOfferedAt: string
}

export interface ApplicationStageCountDto {
    stage: string
    count: number
}

export interface RecruitmentStatsDto {
    totalVacancies: number
    activeVacancies: number
    totalApplications: number
    applicationsByStage: ApplicationStageCountDto[]
    upcomingConfirmedInterviews: ConfirmedInterviewDto[]
    pendingCandidates: PendingCandidateDto[]
}

// ── Onboarding ────────────────────────────────────────────────────────────────

export interface EmployeeStatusCountDto {
    status: string
    count: number
}

export interface OnboardingStatsDto {
    totalEmployees: number
    activeEmployees: number
    pendingEmployees: number
    employeesByStatus: EmployeeStatusCountDto[]
}

// ── Combined ──────────────────────────────────────────────────────────────────

export interface DashboardStatsDto {
    recruitment: RecruitmentStatsDto
    onboarding: OnboardingStatsDto
}

class DashboardService {
    async getStats(organizationId: string): Promise<DashboardStatsDto> {
        const response = await apiClient.get(
            `/organizations/${organizationId}/dashboard/stats`,
        )
        return response.data as DashboardStatsDto
    }
}

export const dashboardService = new DashboardService()
